module.exports = __webpack_public_path__ + "static/media/text.e211e4e9.svg";